export enum ExperiencePropertyTwoToFourUnitStructureType {
    Two = 0,
    Three = 1,
    Four = 2,
}

export const ExperiencePropertyTwoToFourUnitStructureTypeOptions = [
    {
        id: ExperiencePropertyTwoToFourUnitStructureType.Two,
        name: '2-plex',
    },
    {
        id: ExperiencePropertyTwoToFourUnitStructureType.Three,
        name: '3-plex',
    },
    {
        id: ExperiencePropertyTwoToFourUnitStructureType.Four,
        name: '4-plex',
    },
];
